import { render, staticRenderFns } from "./prompt-version-deletion.vue?vue&type=template&id=66b63bd4"
import script from "./prompt-version-deletion.vue?vue&type=script&lang=js"
export * from "./prompt-version-deletion.vue?vue&type=script&lang=js"
import style0 from "./prompt-version-deletion.vue?vue&type=style&index=0&id=66b63bd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports